import {useMemo} from "react";
import {useLocation, matchPath} from "react-router-dom";

export const DEFAULT_ROUTE_PATTERNS = ["/:channel/:product/:contentType"];

function findFirstMatchingPath(paths, currentPath) {
  for (const path of paths) {
    const match = matchPath(path, currentPath);
    if (match) return match;
  }
  return null;
}

export function useRouteParams(paths = DEFAULT_ROUTE_PATTERNS) {
  const {pathname} = useLocation();
  return useMemo(() => {
    const match = findFirstMatchingPath(paths, pathname);
    return match?.params ?? {};
  }, [paths, pathname]);
}


